"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const levels_1 = __importStar(require("./util/levels"));
const levelLog_1 = __importDefault(require("./util/levelLog"));
const createScribeLogger_1 = __importDefault(require("./util/createScribeLogger"));
const convertStringToLogLevelName_1 = require("./util/convertStringToLogLevelName");
const defaultOpts = {
    logToConsole: process.env.NODE_ENV !== 'production',
};
const createLogger = (appName, options = {}) => {
    const { name: optName, logToConsole, scribeUrl, sessionId, context: optContext, } = Object.assign(Object.assign({}, defaultOpts), options);
    const targetLevel = options.logLevel || process.env.NODE_ENV === 'production' ? 'info' : 'trace';
    const context = optContext || {};
    const liveContext = {};
    const name = optName || '';
    const scribe = scribeUrl ? (0, createScribeLogger_1.default)(scribeUrl) : undefined;
    // default to info if not set
    const scribeTargetLevel = (0, convertStringToLogLevelName_1.isLogLevelName)(process.env.REACT_APP_SCRIBE_TARGET_LEVEL)
        ? process.env.REACT_APP_SCRIBE_TARGET_LEVEL
        : 'info';
    const levelLoggers = levels_1.default.reduce((result, level) => (Object.assign(Object.assign({}, result), { [level.name]: (...args) => (0, levelLog_1.default)({
            appName,
            level,
            name,
            logToConsole,
            scribe,
            sessionId,
            targetLevel,
            scribeTargetLevel,
            context,
            liveContext,
            args,
        }) })), {});
    return {
        extend: (extendedName) => {
            return createLogger(appName, Object.assign(Object.assign({}, options), { name: extendedName, context }));
        },
        setContextValue: (key, value) => {
            if (typeof value === 'function') {
                liveContext[key] = value;
            }
            else {
                context[key] = value;
            }
        },
        removeContextValue: (key) => delete context[key],
        trace: levelLoggers.trace,
        isTrace: () => (0, levels_1.isLevelActive)('trace', targetLevel),
        debug: levelLoggers.debug,
        isDebug: () => (0, levels_1.isLevelActive)('debug', targetLevel),
        info: levelLoggers.info,
        isInfo: () => (0, levels_1.isLevelActive)('info', targetLevel),
        warn: levelLoggers.warn,
        isWarn: () => (0, levels_1.isLevelActive)('warn', targetLevel),
        error: levelLoggers.error,
        isError: () => (0, levels_1.isLevelActive)('error', targetLevel),
    };
};
exports.default = createLogger;
//# sourceMappingURL=createLogger.js.map